import React from 'react';
import { Placeholder } from '@components/common/Placeholder';

export const ServerError: React.FC = () => {
  return (
    <Placeholder 
      title="500 - Server Error" 
      description="An unexpected server error occurred."
    />
  );
};